import { Component, OnInit } from '@angular/core';
import { ApiResource } from './resources/api.resource';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'portal-davivienda';
  useTemplate = null;
  info = null;

  public configuracion: any;

  constructor(private resource: ApiResource) {
    /*
    console.warn(window.top);
    console.warn(window.top);
    console.warn(window.top.location.href);
    console.warn( window.location.href);
    */
   if (window.top != window.self) {
    console.warn( "No tiene permisos para realizar esta accion");
    window.top.location.href = window.location.href;
  }
   }

  ngOnInit() {
    this.obtnerPopups();
  }

  obtnerPopups() {
    this.resource.obtnerPopups().subscribe(resp => {

      this.info = {
        begin_date: null,
        end_date: null,
        id: null,
        mail: null,
        name: null,
        subtitle: null,
        title: null,
        type: null,
        page: null,
        url: null,
        img: null,
        video: null,
      };

      let popups = resp.response;
      if (popups.length > 0) {
        const lena = popups.length;

        for (let a = 0; a < lena; a++) {
          const item = popups[a];
          const current_date = new Date();
          const begin_date = this.parseDate(item.begin_date);
          const end_date = this.parseDate(item.end_date);


          if (
            current_date.getTime() >= begin_date.getTime() &&
            current_date.getTime() <= end_date.getTime()
          ) {
            this.info = {
              ...this.info,
              ...item,
              page: item.page ? item.page + '.html' : null,
            };

            break;
          }
        }

        if (this.info.id === null) {
          return false;
        }

        switch (this.info.type) {
          case 'Texto':
            this.useTemplate = 'text';
            break;
          case 'Imagen':
            this.useTemplate = 'image';
            break;
          case 'Video':
            this.useTemplate = 'video';
            break;
        }

        // l(this.useTemplate);

        const currentUUID = this.info.page;
        const regxp = /^(\/?portal_principal_).*/.exec(currentUUID);
        let allow = true;


        $('.popup-container').addClass('show');

        setTimeout(() => {
          if ((
            $.fn.fullpage.setAllowScrolling !== undefined &&
            $.fn.fullpage.setKeyboardScrolling !== undefined
          )) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
            // $.fn.fullpage.setMouseWheelScrolling(true);
            // $.fn.fullpage.setMouseWheelScrolling(false);

            // console.warn('setAllowScrolling', $.fn.fullpage.setAllowScrolling);
            // l('setKeyboardScrolling', $.fn.fullpage.setKeyboardScrolling);
          }
        }, 1200);

      }

      // l(this.info);


    }, err => {

    });
  }


  private parseDate(date) {
    let newDate: any;
    let d1 = date.split(' ')[0].split('/');
    let d2 = date.split(' ')[1];
    let popDate = [
      [d1[1], d1[0], d1[2]].join('/'),
      d2,
    ].join(' ');
    newDate = new Date(popDate);
    return newDate;
  }

  closeModal() {
    localStorage.removeItem("configuracion");
    $('.popup-container').removeClass('show');

    if (this.useTemplate === 'video') {
      const $video = $('.popup-container .style-video .video');

      if ($video.length === 1) {
        $video[0].pause();
        $video[0].currentTime = 0;
      }
    }

    $.fn.fullpage.setAllowScrolling(false);
    $.fn.fullpage.setKeyboardScrolling(false);
  }

  closeModalResp() {
    localStorage.removeItem("configuracion");
    const $modal = $('.modal-act-wrapper');

    $modal.removeClass('active');
  }

  enviarCorreo() {

    event.preventDefault();

    let $modal = $('.modal-act-wrapper');
    let $form = $('.popup-container form');
    let $email = $('.popup-container form [type="email"]');
    let to = JSON.parse(localStorage.getItem("configuracion"));
    let data = {
      form_data: { email: $email.val() },
      form_name: "Davivienda Homepage Popup",
      to: to
    };
    this.resource.sendEmail(data).subscribe(resp => {
      let $msg = $modal.find('.title');

      // l({ resp });

      if (resp.response == 'Success.') {
        $msg.text('El mensaje ha sido enviado satisfactoriamente');
        $form[0].reset();
      } else {
        $msg.text('Ha ocurrido un problema, intente más tarde');
      }

      let hideModal = () => {
        setTimeout(() => {
          $modal.removeClass('active');
          this.closeModalResp();
          this.closeModal();
        }, 2000);
      };

      $modal.addClass('active');
      hideModal();



    }, err => {
      let $msg = $modal.find('.title');
      $msg.text('Ha ocurrido un problema, intente más tarde');
      let hideModal = () => {
        setTimeout(() => {
          $modal.removeClass('active');
          this.closeModalResp();
          this.closeModal();
        }, 2000);
      };

      $modal.addClass('active');
      hideModal();
    });
  }





}
